import React, { useEffect, useState } from "react";
import styles from "./qrstyle.module.css";
import Loaderspinner from "../Loader/Loaderspinner";
import Playstoreimg from "../../assets/Getitonplay.png";
import qrcode from "../../assets/downloadqr.png";

const{REACT_APP_CLIENT_TOKEN} = process.env;
const QRCard = ({
  selectedDocument,
  vc,
  schemaProps,
  selectedRegistryData,
  clearCreate,
  setIssueVerfied,
  doneIssue,
  setDoneIssue,
  setAlreadyExist,
  selectedSchemaData,
}) => {
  const [qrData, setQrData] = useState();
  const [inactiveQR, setInactiveQr] = useState(false);
  const title =
    selectedDocument === "Certificate Schema" ? "Certificate" : "Identity";
  const fetchQRtoIssue = () => {
    setInactiveQr(false);
    fetch(`${process.env.REACT_APP_WALLET_URL}/auth/getVcQr?type=vcissue`, {
      method: "GET",
      credentials: "omit",
      headers: {
        "Authorization": `Bearer ${REACT_APP_CLIENT_TOKEN}`
      }
    })
      .then((response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            setQrData(data);
          });
        } else {
          response.json().then((data) => {
            // console.log(data.error);
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  useEffect(() => {
    fetchQRtoIssue();
  }, []);

  useEffect(() => {
    if (qrData) {
      const statusCheckQRissue = setInterval(() => {
        fetch(
          `${process.env.REACT_APP_WALLET_URL}/auth/checkVC?challenge=${qrData.vc.challenge}`,
          {
            headers: {
              Authorization: `Bearer ${REACT_APP_CLIENT_TOKEN}`,
            },
          }
        )
          .then((response) => {
            if (response.status === 200) {
              response.json().then((data) => {
                if (Object.keys(data).includes("session")) {
                  clearInterval(statusCheckQRissue);
                  issueVCWallet(data.session);
                }
              });
            } else {
              response.json().then((data) => {
                // console.log(data);
              });
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }, 3000);
      setTimeout(() => {
        clearInterval(statusCheckQRissue);
        setInactiveQr(true);
      }, 60000);
      return () => {
        clearInterval(statusCheckQRissue);
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qrData]);

  const issueVCWallet = async (session) => {
    const dataDocument = {
      document: "document",
      vc: JSON.parse(vc),
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_WALLET_URL}/message/create/${session.holderDid}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${REACT_APP_CLIENT_TOKEN}`,
          },
          body: JSON.stringify({
            id: session.challenge,
            type: "identity",
            fromDid: vc.issuer,
            toDid: session.holderDid,
            message: dataDocument,
            details: {
              meta: "endpoint-received",
              documentTitle: title,
            },
          }),
        }
      );

      if (response.status === 409) {
        setAlreadyExist(true);
      }

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          `Failed to issue VC: ${errorData.message || response.statusText}`
        );
      }

      const responseData = await response.json();
      if (response.ok) {
        setDoneIssue(true);
        setInactiveQr(true);
        setIssueVerfied(true);
      }
    } catch (error) {
      console.error("Error while issuing VC:", error);
    }
  };
  

  return (
    <div className="marginBT">
      <div className="row m-2">
        <div className="col-md-6 mt-2 mx-auto">
          <div className="card">
            <div className="row ">
              <div className="col-md-6">
                <div className={styles.qrblock}>
                  {qrData ? (
                    <div>
                      <div className="imgDiv">
                        <img
                          src={qrData.qr}
                          alt="background"
                          className={
                            inactiveQR ? styles.qrImage : styles.qrImageop
                          }
                        />
                        <span
                          className={
                            inactiveQR ? styles.overlayRet : styles.nodis
                          }
                          onClick={fetchQRtoIssue}
                        >
                          <div className="imgICo">
                            <img
                              src="refresh.png"
                              className={styles.refershImg}
                              alt="background"
                            />
                          </div>
                          <p className={styles.refreshText}>
                            Refresh the QR code
                          </p>
                        </span>
                        {/* <span className={doneIssue ? "overlayRet" : "nodis"}>
                          <div className="imgICo">
                            <img
                              src="refresh.png"
                              className="refershImg"
                              alt="background"
                            />
                          </div>
                          <p className="imgICo">Issued to Wallet</p>
                        </span> */}
                      </div>
                    </div>
                  ) : (
                    <Loaderspinner />
                  )}
                </div>
              </div>
              <div className="col-md-6 d-flex justify-content-center align-items-center text-start">
                <div>
                  <p className="qr-text pe-none ">
                    <span>
                      Scan the QR to issue verifiable credential to Dhiway
                      Wallet
                    </span>
                  </p>

                  <div className="d-flex justify-content-center align-items-center">
                    <div className="image-container">
                      <a
                        href={`https://play.google.com/store/apps/details?id=com.dhiway.app.batua&pcampaignid=web_share`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          className={styles.storeiCons}
                          src={Playstoreimg}
                          alt={`Play store pic`}
                        />
                      </a>
                      <div className="qr-tooltip">
                        <img src={qrcode} alt="QR Code" />
                        <p className="qr-textmodal"> Scan to get the app</p>
                      </div>
                    </div>
                    {/* <img
                      className={styles.storeiCons}
                      src={Iosstoreimg}
                      alt={`ios store pic`}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* {doneIssue ? (
        <div className="d-flex justify-content-center align-items-center">
          <button className="btn btn-primary my-3" onClick={clearCreate}>
            Clear
          </button>
        </div>
      ) : null} */}
    </div>
  );
};

export default QRCard;
